import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Switch } from 'antd';
import { isAppModule } from '@utils/constants';
import { StyledAutoRefreshComponent, StyledAutoRefreshSpan } from './styled';
import { noBrushSelector } from '@store/trends/birdChart/selectors';
import { summaryWidgetsSelector } from '@store/summaryWidgets/selector';
import { networkRequestSelector } from '@store/networkRequest/selector';
import { setDrillDown, setSyncedAutoRefreshState } from '@store/networkRequest/actions';
import { setSlice } from '@store/trends/birdChart/actions';
import useFirstRender from '@src/hooks/utils/useFirstRender';
import apptracker from '@utils/sensor/apptracker';
import { SUMMARY_PANEL_TYPE } from '@components/top-widget-panel/constants';
import useSetupLiveMode from './hooks/useSetupLiveMode';
import { AUTO_REFRESH_TOGGLE } from '@src/utils/sensor/track';

const AutoRefreshToggle = () => {
  const [autoRefresh, setAutoRefresh] = useState(true);
  const noBrushSelected = useSelector(noBrushSelector);
  const { type } = useSelector(summaryWidgetsSelector);
  const { drillDown } = useSelector(networkRequestSelector);
  const dispatch = useDispatch();

  const first = useFirstRender();
  const { refreshHandler } = useSetupLiveMode({ autoRefresh });

  const isAppNetwork = isAppModule && type === SUMMARY_PANEL_TYPE.NETWORK && drillDown;

  useEffect(() => {
    // disable auto refesh when there is an active slice on trends charts
    if (!first && !noBrushSelected) {
      setAutoRefresh(false);
      if (isAppNetwork) {
        dispatch(setSyncedAutoRefreshState(false));
      }
    }
  }, [noBrushSelected, first, isAppNetwork, dispatch]);

  useEffect(() => {
    // disable auto refesh when there is drill down
    if (!first && isAppNetwork) {
      setAutoRefresh(false);
      dispatch(setSyncedAutoRefreshState(false));
    }
  }, [dispatch, first, isAppNetwork]);

  // unmounting the component, clear the auto refresh state
  useEffect(() => {
    return () => {
      if (isAppNetwork) {
        dispatch(setSyncedAutoRefreshState(true));
      }
    };
  }, [dispatch, isAppNetwork]);

  const onChange = () => {
    // enabling auto refresh
    if (!autoRefresh) {
      apptracker(AUTO_REFRESH_TOGGLE, { status: 'enabled' });
      dispatch(setSlice([0, 100], [0, 0])); // clear slice
      dispatch(setDrillDown(false)); // clear drill down
      refreshHandler(); // immediate refresh
    }
    apptracker(AUTO_REFRESH_TOGGLE, { status: 'disabled' });
    setAutoRefresh(!autoRefresh);
    if (isAppNetwork) {
      dispatch(setSyncedAutoRefreshState(!autoRefresh));
    }
  };

  return (
    <StyledAutoRefreshComponent>
      <StyledAutoRefreshSpan>{'Auto Refresh:'}</StyledAutoRefreshSpan>
      <Switch size="small" checked={autoRefresh} onChange={onChange} />
    </StyledAutoRefreshComponent>
  );
};

export default AutoRefreshToggle;
